import { TempIntegrityDetail } from 'components/temp-integrity'
import { Switch } from 'devextreme-react/switch'
import React, { FC, Fragment, useRef } from 'react'
import { CSSTransition } from 'react-transition-group'
import { TrailerTemperature } from 'services/types'
import './temp-integrity-card.scss'

type Props = {
    title: string,
    temperature: TrailerTemperature,
    valueChanged: (arg: TrailerTemperature) => void,
}

export const TempIntegrityCard: FC<Props> = ({ title, temperature, valueChanged }) => {

    const isSetChanged = (newValue: boolean): void => valueChanged({ isSet: newValue, setValue: newValue ? temperature.setValue : null, actualValue: newValue ? temperature.actualValue : null })
    const tempValuesChanged = (setValue: number | null, actualValue: number | null): void => valueChanged({ isSet: temperature.isSet, setValue: setValue, actualValue: actualValue })
    const tempIntegrityRef = useRef(null)

    const headingText: string = temperature.isSet ? title : `${title} (Not Set)`

    return (
        <div className={'card-material'}>
            <div className={'temp-title'}>
                <div className={'temp-heading-container'}>
                    <div className={`temp-heading${temperature.isSet ? '' : '-not-set'}`}>{headingText}</div>
                </div>
                <div className={'temp-set'}>
                    <Switch value={temperature.isSet} onValueChanged={(e) => isSetChanged(e.value)} />
                </div>
            </div>
            <Fragment>
                <CSSTransition nodeRef={tempIntegrityRef} appear={temperature.isSet} in={temperature.isSet} classNames={'animated-expand-card'} timeout={500}>
                    <div ref={tempIntegrityRef} className={'animated-expand-card'}>
                        <TempIntegrityDetail temperature={temperature} valueChanged={tempValuesChanged} />
                    </div>
                </CSSTransition>
            </Fragment>
        </div>
    )
}